import { Dialog, DialogProps } from "@mui/material";
import React from "react";

interface ExtraLargeDialogProps extends DialogProps {
  screenPercentage?: number;
}

const ExtraLargeDialog: React.FC<ExtraLargeDialogProps> = ({
  screenPercentage = 90,
  children,
  ...props
}) => {
  const percentage = `${screenPercentage}%`;

  return (
    <Dialog
      {...props}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: percentage,
          height: percentage,
          maxWidth: "none",
          maxHeight: "none",
          resize: "both",
          overflow: "auto",
          minWidth: "400px",
          minHeight: "300px",
          ...props.PaperProps?.sx,
        },
      }}
    >
      {children}
    </Dialog>
  );
};

export default ExtraLargeDialog;
